export const HeaderHeight = {
  Desktop: '64px',
  Mobile: '48px',
};
